import { useQueryClient } from '@tanstack/react-query';
import * as React from 'react';
import { RemoteEventsViewModel } from '../../extViewmodels/RemoteEventsViewModel';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { SUPPORT_QUERY_KEYS } from './supportQueryHelpers';

export function useSupportNotificationsRealtime() {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	const accountId = userSession?.account?.id;
	const userId = userSession?.user?.id;

	React.useEffect(() => {
		if (!accountId || !userId) return undefined;

		const remoteEvents = new RemoteEventsViewModel(userSession);
		let disposed = false;
		let subscription: { dispose: () => void } | undefined;

		remoteEvents
			.connect()
			.then(() => {
				if (disposed) {
					void remoteEvents.permanentlyDisconnect();
					return;
				}

				subscription = remoteEvents.addEventHandler(`User.${userId}.SupportNotification.#`, () => {
					queryClient.invalidateQueries({ queryKey: SUPPORT_QUERY_KEYS.notifications.all() });
				});
			})
			.catch(() => {
				// Polling and focus refetch cover WebSocket failures.
			});

		return () => {
			disposed = true;
			subscription?.dispose();
			void remoteEvents.permanentlyDisconnect();
		};
	}, [accountId, queryClient, userId, userSession]);
}
